import axiosApi from '../../axiosApi'

// initial state
const state = {
  groups: [],
  currentGroup: {},
  userGroups: []
}

// getters
const getters = {
  getList: (state) => {
    return state.list
  }
}

// actions
const actions = {
  add ({commit, state}, payload) {
    return axiosApi.post(`/groups/addNewGroup`, payload)
      .then(response => {
        if (payload.image.length > 0) {
          return axiosApi.post(`/groups/uploadGroupPicture/${response.data.group.id}`, payload.formData).then((res) => {
            return res.data
          }).catch(e => {
            console.log(e)
          })
        } else {
          return response.data
        }
      })
      .catch(e => {
        console.log(e)
      })
  },
  edit ({commit, state}, payload) {
    return axiosApi.post(`/groups/editGroup`, payload)
      .then(response => {
        if (payload.groupData.image.length > 0) {
          return axiosApi.post(`/groups/uploadGroupPicture/${response.data.groupId}`, payload.formData).then((res) => {
            return res.data
          }).catch(e => {
            console.log(e)
          })
        } else {
          return response.data
        }
      })
      .catch(e => {
        console.log(e)
      })
  },
  addFriendInGroup ({commit, state}, payload) {
    return axiosApi.post(`/groups/addFriendInGroup`, {userId: payload.userId, groupId: payload.groupId})
      .then(response => {
        return response.data
      })
      .catch(e => {
        return e.response
      })
  },
  getAllGroups ({commit, state}, payload) {
    return axiosApi.get(`/groups/getAllGroups`, payload)
      .then(response => {
        // commit('setGroups', response.data.groups)
        return {groups: response.data.groups}
      })
      .catch(e => {
        console.log(e)
      })
  },
  getUserGroups ({commit, state}) {
    return axiosApi.get(`/groups/getUserGroups`)
      .then(response => {
        commit('setUserGroups', response.data.groups)
        return {groups: response.data.groups}
      })
      .catch(e => {
        console.log(e)
      })
  },
  getGroupById ({commit, state}, payload) {
    return axiosApi.get(`/group/getGroupById/${payload.groupId}`)
      .then(response => {
        commit('setCurrentGroup', response.data.group)
        return {group: response.data.group}
      })
      .catch(e => {
        console.log(e)
      })
  },
  deleteGroup ({commit, state}, payload) {
    return axiosApi.delete(`/group/delete/${payload}`)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  deleteGroupMember ({commit, state}, payload) {
    return axiosApi.delete(`/group/deleteMember/${payload.memberId}/${payload.groupId}`)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  deleteGroupImg ({commit, state}, payload) {
    return axiosApi.delete(`/group/deleteImg/${payload}`)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  deleteGroupReq ({commit, state}, payload) {
    return axiosApi.delete(`/groupReq/delete/${payload}`)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  sendGroupRequest ({commit}, payload) {
    return axiosApi.post(`/group/saveGroupRequest`, {
      data: JSON.stringify(payload)
    })
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  acceptGroupRequest ({commit, state}, payload) {
    return axiosApi.post(`/group/acceptRequest`, {
      data: JSON.stringify(payload)
    }).then(response => {
      return response.data
    }).catch(e => {
      console.log(e)
    })
  }
}

// mutations
const mutations = {
  setGroups (state, groups) {
    state.groups = groups
  },
  setCurrentGroup (state, group) {
    state.currentGroup = group
  },
  setUserGroups (state, groups) {
    state.userGroups = groups
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/groups.js